import Colors from "../../../theme/colors";

const style = {
  container: {
    backgroundColor: Colors.white,
    borderRadius: "8px",
    height: "100",
  },
  search: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
};

export default style;
